import React from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  IconButton,
  Grid,
  MenuItem,
  InputLabel,
  Input,
  Switch,
  FormControlLabel,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Substatus } from './types';
import TriggerForm from './TriggerForm.tsx';
import CloseIcon from '@mui/icons-material/Close';
import CommonBadges from '../../Shared/Badges/index.jsx';

type Props = {
  substatuses: Substatus[];
  onChange: (updated: Substatus[]) => void;
  validationError?: any;
  typeOfSubStatusList?: any[];
};

const SubstatusList: React.FC<Props> = ({
  substatuses = [],
  onChange,
  validationError = {},
  typeOfSubStatusList = [],
}) => {
  const updateSubstatus = (index: number, field: keyof Substatus, value: any) => {
    const newSubstatuses = [...substatuses];
    newSubstatuses[index][field] = value;
    onChange(newSubstatuses);
  };

  const addTrigger = (index: number) => {
    const updated = [...substatuses];
    updated[index].triggers = updated[index].triggers || [];
    updated[index].triggers.push({ trigger_type: 'sms', stakeholder_id: '' } as any);
    onChange(updated);
  };

  const removeTrigger = (subIndex: number, triggerIndex: number) => {
    const updated = [...substatuses];
    (updated[subIndex].triggers || []).splice(triggerIndex, 1);
    onChange(updated);
  };

  const addSubstatus = () => {
    onChange([...(substatuses || []), { name: '', triggers: [] }]);
  };

  const removeSubstatus = (index: number) => {
    const updated = [...substatuses];
    updated.splice(index, 1);
    onChange(updated);
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Sub Statuses
      </Typography>

      {(substatuses || []).map((sub, idx) => (
        <Box key={idx} sx={{ mb: 3, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
          <Box
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}
          >
            <Typography variant="subtitle1" fontWeight={500}>
              Substatus {idx + 1}
            </Typography>
            <IconButton size="small" color="error" onClick={() => removeSubstatus(idx)}>
              <DeleteIcon />
            </IconButton>
          </Box>

          {/* NEW: Type of Status before Substatus Name */}
          <Grid container spacing={1}>
            <Grid item xs={12} sm={3}>
              <TextField
                select
                fullWidth
                size="small"
                label={
                  <Typography component="span">
                    Type of status <span style={{ color: 'red' }}>*</span>
                  </Typography>
                }
                value={sub?.type_of_status ?? ''}
                onChange={(e) => {
                  const val = e.target.value;
                  updateSubstatus(idx, 'type_of_status', val);
                }}
                margin="dense"
                variant="outlined"
                sx={{ mb: 2 }}
                error={!!validationError?.[`substatuses[${idx}].type_of_status`]}
                helperText={validationError?.[`substatuses[${idx}].type_of_status`]}
              >
                {typeOfSubStatusList?.map((opt, index) => (
                  <MenuItem key={index} value={opt?.key_name}>
                    {opt?.alias_name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                size="small"
                fullWidth
                value={sub.name}
                label={
                  <Typography component="span">
                    Substatus Name <span style={{ color: 'red' }}>*</span>
                  </Typography>
                }
                margin="dense"
                variant="outlined"
                onChange={(e) => updateSubstatus(idx, 'name', e.target.value)}
                error={!!validationError?.[`substatuses[${idx}].name`]}
                helperText={validationError?.[`substatuses[${idx}].name`]}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Box
                sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 1 }}
              >
                <InputLabel htmlFor={`substatus-color-${idx}`}>Choose a Color</InputLabel>
                <Input
                  id={`substatus-color-${idx}`}
                  type="color"
                  value={sub?.colorCode || '#1976d2'}
                  onChange={(e) => {
                    const selectedColor = e.target.value.toLowerCase();
                    updateSubstatus(idx, 'colorCode', selectedColor);
                  }}
                  style={{
                    width: '80px',
                    height: '40px',
                    border: 'none',
                    cursor: 'pointer',
                  }}
                />
                {sub?.colorCode && (
                  <CommonBadges
                    value={sub?.colorCode || 'Selected Color'}
                    variant="outlined"
                    color="primary"
                  />
                )}
                <IconButton
                  onClick={() => updateSubstatus(idx, 'colorCode', '')}
                  size="small"
                  aria-label="clear color"
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={!!sub?.active}
                    onChange={(e) => updateSubstatus(idx, 'active', e.target.checked)}
                    name="substatus-active"
                  />
                }
                label="Active"
              />
            </Grid>
          </Grid>
          {/* <Box key={idx} sx={{ mb: 3, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, mt: 1 }}>
              <InputLabel htmlFor={`substatus-color-${idx}`}>Choose a Color</InputLabel>
              <Input
                id={`substatus-color-${idx}`}
                type="color"
                value={sub?.colorCode || "#1976d2"}
                onChange={(e) => {
                  const selectedColor = e.target.value.toLowerCase();
                  updateSubstatus(idx, "colorCode", selectedColor);
                }}
                style={{
                  width: "80px",
                  height: "40px",
                  border: "none",
                  cursor: "pointer",
                }}
              />
              {sub?.colorCode && (
                <CommonBadges
                  value={sub?.colorCode || "Selected Color"}
                  variant='outlined'
                  color='primary'
                />
              )}
              <IconButton
                onClick={() => updateSubstatus(idx, "colorCode", "")}
                size="small"
                aria-label="clear color"
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box> */}
<Typography variant="h6" sx={{ mb: 1 }}>
    Trigger & Activity
  </Typography>
          {(sub?.triggers || []).map((trigger, tIdx) => (
            <TriggerForm
              key={tIdx}
              sNo={tIdx}
              trigger={trigger as any}
              onChange={(updated) => {
                const newTriggers = [...(sub.triggers || [])];
                newTriggers[tIdx] = updated as any;
                updateSubstatus(idx, 'triggers', newTriggers);
              }}
              onRemove={() => removeTrigger(idx, tIdx)}
            />
          ))}

          <Button onClick={() => addTrigger(idx)} variant="outlined" size="small" sx={{ mt: 1 }}>
            Add Trigger
          </Button>
        </Box>
      ))}

      <Button variant="outlined" size="small" onClick={addSubstatus}>
        Add Substatus
      </Button>
    </Box>
  );
};

export default SubstatusList;
